module.exports = __webpack_public_path__ + "img/jordbruk_paavirkning_hymo.af9f46d7.jpg";